import { useState, useEffect } from 'react';

interface OrdersProps {
  apiEndpoint: string;
}

interface Order {
  order_id: string;
  name: string;
  email: string;
  phone: string;
  product: string;
  price: number;
  status: string;
  payment_status: string;
  created_at: string;
}

export default function Orders({ apiEndpoint }: OrdersProps) {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchOrders();
  }, [apiEndpoint, filter]);

  const fetchOrders = async () => {
    try {
      let url = `${apiEndpoint}/api/sv9/orders`;
      if (filter !== 'all') {
        url += `&status=${filter}`;
      }
      const response = await fetch(url, { headers: { 'x-router-secret': import.meta.env.VITE_ROUTER_SECRET } });
      const data = await response.json();
      setOrders(data.orders || []);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch orders:', error);
      setLoading(false);
    }
  };

  if (loading) return <div className="card">Loading...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1>Orders</h1>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{
            padding: '10px 16px',
            borderRadius: '8px',
            border: '1px solid #ddd'
          }}
        >
          <option value="all">All Orders</option>
          <option value="new">New</option>
          <option value="confirmed">Confirmed</option>
          <option value="delivered">Delivered</option>
          <option value="paid">Paid</option>
        </select>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Contact</th>
              <th>Product</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.order_id}>
                <td>{order.order_id}</td>
                <td>{order.name}</td>
                <td>
                  <div>{order.email}</div>
                  <div style={{ fontSize: '0.85rem', color: '#666' }}>{order.phone}</div>
                </td>
                <td>{order.product}</td>
                <td>฿{order.price?.toLocaleString()}</td>
                <td>
                  <span className={`status ${order.status}`}>{order.status}</span>
                </td>
                <td>{new Date(order.created_at).toLocaleDateString('th-TH')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
